import { Skeleton } from "primereact/skeleton";

export function CompletedCountColumn({ rowData, loading }) {
  if (loading) return <Skeleton />;

  const count = rowData.lessonsCompleteCount;
  const lessonLabel = count === 1 ? "lesson" : "lessons";

  return (
    <div className="flex flex-col body-sm">
      <span className="text-muted-aaa">Completed</span>
      <span className="flex">
        <i className="pi-stack text-xs mr-[8px]" />
        {count} {lessonLabel}
      </span>
    </div>
  );
}
